export const GET_ALL_SPECIALIZATIONS = "GET_ALL_SPECIALIZATIONS";
export const UPDATE_SPECIALIZATION = "UPDATE_SPECIALIZATION";
